module.exports = __webpack_public_path__ + "static/media/report1_1.c1d64c24.png";